export default __webpack_public_path__ + "static/media/image.66bb8ef9.png";